'use client';

import { c as _c } from "react/compiler-runtime";
import type { MouseEvent } from 'react';
import { useProgress } from '@bprogress/next';
import Image from 'next/image';
import Link from 'next/link';
import type { SiteSlugType } from '@/lib/preferredSite';
type VisualSiteLinkProps = {
  onClickAction?: (site: SiteSlugType) => void;
  siteSlug: string;
  localeSlug: string;
  imgSrc: string;
};
export function VisualSiteLink(t0) {
  const $ = _c(15);
  const {
    onClickAction,
    siteSlug,
    localeSlug,
    imgSrc
  } = t0;
  const href = `/${siteSlug}/${localeSlug}`;
  const name = siteSlug === "au" ? "Australia" : "New Zealand";
  const {
    stop
  } = useProgress();
  let t1;
  if ($[0] !== onClickAction || $[1] !== siteSlug || $[2] !== stop) {
    t1 = function handleClick(e) {
      const isOnCurrentSite = window.location.pathname.startsWith(`/${siteSlug}/`);
      if (isOnCurrentSite) {
        e.preventDefault();
        stop();
      }
      onClickAction?.(siteSlug as SiteSlugType);
    };
    $[0] = onClickAction;
    $[1] = siteSlug;
    $[2] = stop;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleClick = t1;
  const t2 = `Go to our ${name} site`;
  let t3;
  if ($[4] !== imgSrc) {
    t3 = <Image src={imgSrc} className="object-cover" fill={true} fetchPriority="high" alt="australia" sizes="148px" />;
    $[4] = imgSrc;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      background: "linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0.6) 100%)"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== name) {
    t5 = <div className="relative flex size-full items-center justify-center" style={t4}><span className="flex text-white">{name}</span></div>;
    $[7] = name;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== handleClick || $[10] !== href || $[11] !== t2 || $[12] !== t3 || $[13] !== t5) {
    t6 = <div className="relative w-[148px] h-[64px] bg-gray-300/50 rounded-xl overflow-hidden cursor-pointer"><Link href={href} aria-label={t2} onClick={handleClick}>{t3}{t5}</Link></div>;
    $[9] = handleClick;
    $[10] = href;
    $[11] = t2;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}